export default __webpack_public_path__ + "static/media/bg15.6e59c0f6.svg";